import React from 'react';
import autobind from "autobind-decorator";
import { connect } from 'react-redux';

import { View, Views, Toolbar, Link, Popup } from 'core/components/Framework7';

import services from 'core/services';
import { changeActiveTab } from 'core/module/operations';

import { changeVisibleSearchView, changeVisibleCartView } from 'core/module/operations';

import classes from './styles.module.css';

export class CustomeTab extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      tourViewed: !!services.storage.get('tour_viewed'),
      loginView: !!services.storage.get('login_view'),
      tabAciveInfo: false,
    }

    if (this.state.loginView) {
      services.storage.set('login_view', false);
      this.props.changeActiveTab(3)
    }

    // console.log('loginView:', this.state.loginView)
  }

  changeTab(value) {
    const { tabActive } = this.props
    // console.log('change active tab to:', value)
    if (tabActive == value) return

    this.props.changeActiveTab(value)
  }

  onCartPopupOpened() {
    // console.log('this.$f7.views.cart.router:', this.$f7.views.cart.router);
    this.$f7 && this.$f7.views && this.$f7.views.cart && this.$f7.views.cart.router &&
      this.$f7.views.cart.router.navigate('/cart', { reloadAll: true })
  }

  renderViews() {
    const { loginView, tabAciveInfo } = this.state
    const { env, authorized, tabActive } = this.props
    // console.log('re-rendered')

    return (
      <Views tabs className="safe-areas">
        {/* Tabbar for switching views-tabs */}
        <Toolbar tabbar labels bottom>
          <Link
            tabLink="#view-home"
            icon="mdi-home"
            tabLinkActive={!loginView}
            text="خانه"
            className={'tab-link-main'}
            onClick={() => this.changeTab(1)}
          />
          <Link
            tabLink="#view-category"
            icon="mdi-format-list-bulleted"
            text="دسته‌بندی"
            onClick={() => this.changeTab(2)}
          />
          <Link
            tabLink="#view-profile"
            tabLinkActive={loginView}
            icon={authorized ? "mdi-account-edit" : "mdi-account"}
            text={authorized ? "حساب کاربری" : "ورود"}
            onClick={() => this.changeTab(3)}
          />
          <Link
            tabLink="#view-info"
            tabLinkActive={tabActive === 4 && tabAciveInfo}
            className={tabActive === 4 && tabAciveInfo ? 'logo-active' : 'logo-deactive'}
            onClick={() => this.changeTab(4)}>
            <i className="icon logo" />
            {/* <span class="tabbar-label">{'فروشگاه'}</span> */}
          </Link>
        </Toolbar>

        {/* Your main view/tab, should have "view-main" class. It also has "tabActive" prop */}
        <View animate={false} id="view-home" name="home" tab url="/" main tabActive={!loginView} />
        <View animate={false} id="view-category" name="category" tab url="/category" />
        <View animate={false} id="view-profile" name="profile" tab url="/profile" tabActive={loginView} />
        <View animate={false} id="view-info" name="info" tab url="/info" onTabHide={() => this.setState({ tabAciveInfo: false })} onTabShow={() => this.setState({ tabAciveInfo: true })} />
      </Views>
    )
  }

  renderRoutable() {
    <Toolbar tabbar labels bottom>
      <Link
        tabLink
        tabLinkActive={!loginView}
        icon="mdi-home"
        text="خانه"
        onClick={() => this.changeTab(1)}
      />
      <Link
        tabLink
        icon="mdi-format-list-bulleted"
        text="دسته‌بندی"
        onClick={() => this.changeTab(2)}
      />
      <Link
        tabLink
        tabLinkActive={loginView}
        icon={authorized ? "mdi-account-edit" : "mdi-account"}
        text={authorized ? "حساب کاربری" : "ورود"}
        onClick={() => this.changeTab(3)}
      />
      <Link
        tabLink
        tabLinkActive={tabActive === 4}
        className={tabActive === 4 ? classes.logoSelected : classes.logoNotSelected}
        onClick={() => this.changeTab(4)}>
        <i className="icon logo" />
      </Link>
    </Toolbar>
  }

  renderPopups() {
    const { visibleSearchView, visibleCartView } = this.props

    return (
      <React.Fragment>
        <Popup
          id={'popup-search-view'}
          tabletFullscreen
          animate={false}
          closeByBackdropClick={false}
          opened={visibleSearchView}
          onPopupClosed={() => this.props.changeVisibleSearchView(false)}
        >
          <View animate={false} id="view-search" name="search" url="/search" />
        </Popup>
        <Popup
          id={'popup-cart-view'}
          tabletFullscreen={false}
          animate={false}
          closeByBackdropClick={true}
          opened={visibleCartView}
          onPopupOpened={this.onCartPopupOpened}
          onPopupClosed={() => { this.props.changeVisibleCartView(false) }}
        >
          <View animate={false} id="view-cart" name="cart" url="/cart" />
        </Popup>
      </React.Fragment>
    )
  }

  render() {
    const { tourViewed } = this.state
    // console.log('tabActive:', tabActive)

    return (
      <React.Fragment>
        {tourViewed && // mobile app &&
          <React.Fragment>
            {/* use for mobile app */}
            {this.renderViews()}
            {/* use for pwa */}
            {/* this.renderRoutable() */}
            {/* render popups */}
            {this.renderPopups()}
          </React.Fragment>
        }
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => ({
  env: state.General.env,
  authorized: state.General.authorized,
  tabActive: state.General.tabActive,
  visibleSearchView: state.General.visibleSearchView,
  visibleCartView: state.General.visibleCartView,
})

const mapFuncToProps = {
  changeActiveTab,
  changeVisibleSearchView,
  changeVisibleCartView,
}

export default connect(
  mapStateToProps,
  mapFuncToProps
)(autobind(CustomeTab))